<script setup>
import { defineProps } from "vue";
import {
  svgProps,
  useSVGAccessibility,
} from "@/composables/useSVGAccessibility";

const props = defineProps({
  ...svgProps,
  fill: { type: String, default: "none" },
  stroke: { type: String, default: "#007f80" },
  strokeWidth: { type: String, default: "2" },
});

const { titleId, computedRole, ariaAttributes } = useSVGAccessibility(props);
</script>

<template>
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    :fill="props.fill"
    :stroke="props.stroke"
    :stroke-width="props.strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="computedRole"
    v-bind="ariaAttributes"
  >
    <template v-if="props.title">
      <title :id="titleId">{{ props.title }}</title>
    </template>
    <path
      d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"
    />
  </svg>
</template>
